// extracted by mini-css-extract-plugin
export default {"panel":"MenuPanel_panel__tXEb4","tab":"MenuPanel_tab__hm51G","icon":"MenuPanel_icon__IErZe","popup":"MenuPanel_popup__80wMt"};